/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { VirtualDndPreview } from './virtual-dnd.service';

@Directive({
  standalone: false,
  selector: '[ghVirtualDndPreview]',
  exportAs: 'ghVirtualDndPreview',
})
export class VirtualDndViewportPreviewDirective implements VirtualDndPreview {
  constructor(public templateRef: TemplateRef<any>,
              public viewContainerRef: ViewContainerRef) {
  }
}
